import { usePaymentContext } from '#contexts/PaymentContext';
import { useThemeContext } from '#contexts/ThemeContext';
import { Product } from '#models/product';
import { useBreakpoints } from '#utils/breakpoint';
import { getImageOriginal, toProductCurrency } from '#utils/product';
import { useProductStyle } from '#utils/style';
import { Box, Dialog, DialogContent, DialogTitle, Divider, makeStyles, Typography } from '@material-ui/core';
import { HighlightOffOutlined } from '@material-ui/icons';
import { ListFeature } from '../Product/components/ListFeature';

interface DialogProps {
  open: boolean;

  setDialogState: (open: boolean) => void;
}

export const ProductDialog = ({ open, setDialogState }: DialogProps) => {
  const {
    state: { paymentProduct: product, dataPayment }
  } = usePaymentContext();
  const classes = useStyles();
  const closeDialog = () => {
    setDialogState(false);
  };
  const imgUrl = getImageOriginal(product as Product);
  const { currency } = useThemeContext();
  const productClasses = useProductStyle();
  const { isLessThanXs } = useBreakpoints();

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth='xs'
      style={{ width: 521, maxWidth: '100vw', margin: 'auto' }}
      PaperProps={{ className: classes.customPaper }}
    >
      <DialogTitle>
        <Box display='flex' justifyContent='flex-end' onClick={closeDialog} style={{ cursor: 'pointer' }}>
          <HighlightOffOutlined color='primary' />
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box px={isLessThanXs ? 2 : 7}>
          <Typography variant='h6' className={`${productClasses.bodyText} semiBold`}>
            Summary
          </Typography>
          <Box display='flex' my={2}>
            <Box width={60} height={60}>
              <img src={imgUrl} alt='product image' className='fitImage' />
            </Box>
            <Box width='calc(100% - 60px)' pl={2}>
              <Typography variant='subtitle2' className={`${productClasses.productTitleText} semiBold`}>
                {product?.name}
              </Typography>
              <Divider />
              <Box display='flex' justifyContent='space-between' alignItems='center' my={0.5}>
                <Typography variant='body2' className={`${productClasses.bodyText} semiBold`}>
                  Payment
                </Typography>
                <Typography variant='h6' className={`${productClasses.priceText} semiBold`}>
                  {currency && toProductCurrency(dataPayment.price, currency.name)}
                </Typography>
              </Box>
              <Divider />
            </Box>
          </Box>
          <Box my={2}>
            <Typography variant='subtitle2' className={`${productClasses.bodyText} semiBold`}>
              What’s included
            </Typography>
            <ListFeature highlights={product?.highlights || []} />
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

const useStyles = makeStyles({
  customPaper: {
    margin: 16,
    width: '100%'
  }
});
